import { Redirect, Router } from '@reach/router';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { TopicsContext } from '../../contexts/Topics.js';
import { UsersContext } from '../../contexts/Users.js';
import * as CSS from './elements/Progress.js';
import ModuleProgress from './ModuleProgress';
import StaffStudentModules from './StaffStudentModules';
import StaffStudentTargets from './StaffStudentTargets';

const Progress = observer(({ studentId, store }) => {
  const usersStore = useContext(UsersContext);
  const topicsStore = useContext(TopicsContext);
  const student = usersStore.getUserById(studentId);
  const loggedInUser = usersStore.getLoggedInUser();
  const hasTargetUpdates = student.private.hasTargetUpdatesInCategory(
    loggedInUser.selectedCategory,
    loggedInUser
  );
  const hasTaskUpdates = student.private.hasTaskUpdatesInCategory(
    loggedInUser.selectedCategory,
    topicsStore,
    loggedInUser
  );

  return (
    <div>
      <CSS.StaffRow>
        <CSS.StaffTabs>
          <CSS.UpdateDot
            show={hasTaskUpdates}
            data-testid={`updates-modulesLink`}
          >
            <CSS.StaffFilterLink to="modules" isfirst>
              Modules
            </CSS.StaffFilterLink>
          </CSS.UpdateDot>
          <CSS.UpdateDot
            show={hasTargetUpdates}
            data-testid={`updates-targets`}
          >
            <CSS.StaffFilterLink to="targets">
              Personal Targets
            </CSS.StaffFilterLink>
          </CSS.UpdateDot>
        </CSS.StaffTabs>
      </CSS.StaffRow>
      <Router primary={false}>
        <Redirect from="/" to="modules" noThrow />
        <StaffStudentModules path="/modules" studentId={studentId} />
        <StaffStudentTargets path="/targets" studentId={studentId} />
        <ModuleProgress
          path="/modules/:moduleId/*"
          studentId={studentId}
          store={store}
        />
      </Router>
    </div>
  );
});

export default Progress;
